import { VisitorModel } from 'client/data/models/visitor';

const xVisitorId = 'x-visitor-id';

/**
 * Returns default API options from context
 * @param {Object} context Model segment context
 */
export const getDefaultApiOptionsFromContext = async context => {
  const visitorId = await context.resolveValue('id', VisitorModel);
  return { headers: { [xVisitorId]: visitorId } };
};

/**
 * Returns default API headers based on visitorId
 * @param {String} visitorId - visitor id
 */
export const getDefaultApiHeaders = visitorId => {
  const visitorIdHeader = visitorId ? { [xVisitorId]: visitorId } : {};

  return { ...visitorIdHeader };
};
